/* Trusted Loan Access - Keyturn motion system.
   Pure vanilla JS. All hidden states are gated behind html.js,
   so no-JS visitors and crawlers always see full content. */
document.documentElement.classList.add('js');

(function () {
  'use strict';

  var reduceMotion = false;
  if (window.matchMedia) {
    try {
      reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      reduceMotion = false;
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function doubleRaf(fn) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(fn);
    });
  }

  /* ---------- Line splitter: per-line skew-slide masks ---------- */
  function splitLines(el) {
    if (el.getAttribute('data-split') === 'done') { return; }
    var nodes = Array.prototype.slice.call(el.childNodes);
    var tokens = [];
    var frag = document.createDocumentFragment();

    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        var words = node.textContent.split(/\s+/);
        words.forEach(function (word) {
          if (!word) { return; }
          var span = document.createElement('span');
          span.className = 'w';
          span.style.display = 'inline-block';
          span.textContent = word;
          tokens.push(span);
          frag.appendChild(span);
          frag.appendChild(document.createTextNode(' '));
        });
      } else if (node.nodeType === 1) {
        node.style.display = 'inline-block';
        tokens.push(node);
        frag.appendChild(node);
        frag.appendChild(document.createTextNode(' '));
      }
    });

    el.textContent = '';
    el.appendChild(frag);

    /* group tokens into visual lines by offsetTop */
    var lines = [];
    var currentTop = null;
    tokens.forEach(function (token) {
      var top = token.offsetTop;
      if (currentTop === null || Math.abs(top - currentTop) > 4) {
        lines.push([]);
        currentTop = top;
      }
      lines[lines.length - 1].push(token);
    });

    el.textContent = '';
    lines.forEach(function (lineTokens, i) {
      var ln = document.createElement('span');
      ln.className = 'ln';
      var lnIn = document.createElement('span');
      lnIn.className = 'ln-in';
      lnIn.style.setProperty('--li', String(i));
      lineTokens.forEach(function (token, j) {
        token.style.display = '';
        lnIn.appendChild(token);
        if (j < lineTokens.length - 1) {
          lnIn.appendChild(document.createTextNode(' '));
        }
      });
      ln.appendChild(lnIn);
      el.appendChild(ln);
    });

    el.setAttribute('data-split', 'done');
  }

  /* ---------- Decode rotator ---------- */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ%#&*+';
  function startDecode(el) {
    var raw = el.getAttribute('data-decode') || '';
    var words = raw.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    if (words.length < 2) { return; }
    var index = 0;

    function scrambleTo(next) {
      var frames = 14;
      var frame = 0;
      var len = next.length;
      var timer = window.setInterval(function () {
        frame += 1;
        var settled = Math.floor((frame / frames) * len);
        var out = '';
        for (var i = 0; i < len; i += 1) {
          if (i < settled || next.charAt(i) === ' ') {
            out += next.charAt(i);
          } else {
            out += GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length));
          }
        }
        el.textContent = out;
        if (frame >= frames) {
          window.clearInterval(timer);
          el.textContent = next;
        }
      }, 42);
    }

    window.setInterval(function () {
      index = (index + 1) % words.length;
      scrambleTo(words[index]);
    }, 3400);
  }

  /* ---------- Main init ---------- */
  ready(function () {

    /* Reveal engine */
    var revealables = Array.prototype.slice.call(document.querySelectorAll('.rv'));
    var splitTargets = Array.prototype.slice.call(document.querySelectorAll('[data-lines], [data-lines-load]'));

    if (!reduceMotion) {
      splitTargets.forEach(splitLines);
    } else {
      splitTargets.forEach(function (el) {
        el.classList.add('lines-in');
      });
    }

    var supportsIO = 'IntersectionObserver' in window;

    if (supportsIO && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            if (entry.target.hasAttribute('data-lines')) {
              entry.target.classList.add('lines-in');
            }
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

      revealables.forEach(function (el) { io.observe(el); });
      splitTargets.forEach(function (el) {
        if (el.hasAttribute('data-lines')) { io.observe(el); }
      });
    } else {
      revealables.forEach(function (el) { el.classList.add('in'); });
      splitTargets.forEach(function (el) { el.classList.add('lines-in'); });
    }

    /* Above-the-fold: fire on load, never wait for scroll */
    doubleRaf(function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-lines-load]')).forEach(function (el) {
        el.classList.add('lines-in');
      });
      Array.prototype.slice.call(document.querySelectorAll('[data-doors-load]')).forEach(function (el) {
        el.classList.add('is-open');
      });
      var heroReveals = document.querySelectorAll('.hero .rv, .bloghero .rv, .notfound .rv');
      Array.prototype.slice.call(heroReveals).forEach(function (el) {
        el.classList.add('in');
      });
    });

    /* Decode rotator */
    if (!reduceMotion) {
      Array.prototype.slice.call(document.querySelectorAll('[data-decode]')).forEach(startDecode);
    }

    /* Header: shrink + mobile toggle + sliding thumb */
    var header = document.querySelector('[data-header]');
    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-shrunk', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      var toggle = header.querySelector('[data-nav-toggle]');
      var nav = header.querySelector('[data-nav]');
      if (toggle && nav) {
        toggle.addEventListener('click', function () {
          var open = nav.classList.toggle('open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      var plate = header.querySelector('[data-plate]');
      var thumb = header.querySelector('[data-thumb]');
      if (plate && thumb) {
        var links = Array.prototype.slice.call(plate.querySelectorAll('[data-navlink]'));
        var currentLink = plate.querySelector('.is-current');

        var moveThumb = function (link) {
          if (!link) {
            thumb.classList.remove('is-set');
            return;
          }
          thumb.style.left = link.offsetLeft + 'px';
          thumb.style.width = link.offsetWidth + 'px';
          thumb.classList.add('is-set');
        };

        moveThumb(currentLink);
        window.addEventListener('resize', function () { moveThumb(currentLink); });
        links.forEach(function (link) {
          link.addEventListener('mouseenter', function () { moveThumb(link); });
          link.addEventListener('focus', function () { moveThumb(link); });
        });
        plate.addEventListener('mouseleave', function () { moveThumb(currentLink); });
      }
    }

    /* Qualifications scrollytelling */
    var qualsWrap = document.querySelector('[data-quals]');
    if (qualsWrap) {
      var qualItems = Array.prototype.slice.call(qualsWrap.querySelectorAll('[data-qual]'));
      var countEl = qualsWrap.querySelector('[data-quals-count]');
      var keyEl = qualsWrap.querySelector('[data-quals-key]');
      var total = qualItems.length;

      var refreshQuals = function () {
        var on = qualsWrap.querySelectorAll('[data-qual].is-on').length;
        if (countEl) { countEl.textContent = String(on); }
        if (keyEl && total > 0) {
          keyEl.style.setProperty('--qturn', Math.round((on / total) * 90) + 'deg');
        }
      };

      if (supportsIO && !reduceMotion) {
        var qio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-on');
              qio.unobserve(entry.target);
              refreshQuals();
            }
          });
        }, { threshold: 0.55 });
        qualItems.forEach(function (item) { qio.observe(item); });
      } else {
        qualItems.forEach(function (item) { item.classList.add('is-on'); });
        refreshQuals();
      }
    }

    /* FAQ accordion */
    Array.prototype.slice.call(document.querySelectorAll('[data-faq]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.fitem');
        if (!item) { return; }
        var open = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  });
})();
